import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { combineLatest } from "rxjs";
import { IKpiSnapshot } from "@gtmhub/kpis";
import { IUnitFormatting } from "@gtmhub/shared/models";
import { KpiDetailsStateService } from "@webapp/kpis/components/kpi-details/services/kpi-details-state.service";
import { Kpi, ProgressIndicatorData } from "@webapp/kpis/models/kpis.models";

@UntilDestroy()
@Component({
  selector: "kpi-progress",
  templateUrl: "kpi-progress.component.html",
  styleUrls: ["kpi-progress.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiProgressComponent implements OnInit {
  public progressIndicatorData: ProgressIndicatorData;
  public currentValue: number;
  public formatting: IUnitFormatting;

  constructor(private kpiDetailsStateService: KpiDetailsStateService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.cdr.detach();

    combineLatest({
      snapshots: this.kpiDetailsStateService.getSnapshots$(),
      kpi: this.kpiDetailsStateService.getKpi$(),
    })
      .pipe(untilDestroyed(this))
      .subscribe(({ kpi, snapshots }) => {
        this.currentValue = this.getKpiCurrentValue(snapshots);
        this.formatting = kpi.formatting;
        this.progressIndicatorData = this.generateProgressIndicatorData(kpi, snapshots);

        this.cdr.detectChanges();
      });
  }

  private getKpiCurrentValue(snapshots: IKpiSnapshot[]): number {
    return snapshots.length > 0 ? snapshots[snapshots.length - 1].value : null;
  }

  private generateProgressIndicatorData(kpi: Kpi, snapshots: IKpiSnapshot[]): ProgressIndicatorData {
    if (snapshots.length === 0) {
      return null;
    }

    const { targetOperator } = kpi;
    const { deltaPercentage } = snapshots[snapshots.length - 1];
    const lessIsBetter = targetOperator === "should_decrease";

    return {
      deltaPercentage,
      lessIsBetter,
    };
  }
}
